import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useAppStore } from "./useAppStore";
import useClerkUser from "./useClerkUser";

const getBaseCacheKey = ({
	orgId,
	projectId,
	appId,
}: {
	orgId: number;
	projectId: number;
	appId: string;
}) => {
	return `org-${orgId}:proj-${projectId}:app-${appId}`;
};
const useCacheKey = () => {
	const {
		currentExamContext: { organizationId, projectId },
	} = useExamContext();

	const appId = useAppStore((state) => state.app?.id) || "";

	const { userLogicalId } = useClerkUser();

	if (!(organizationId && projectId && appId && userLogicalId)) {
		return {
			userCacheKey: "",
			baseCacheKey: "",
			reviewPromptCacheKey: "",
			consentCacheKey: "",
		};
	}

	const baseCacheKey = getBaseCacheKey({
		orgId: organizationId,
		projectId,
		appId,
	});

	const userCacheKey = `${baseCacheKey}:user-${userLogicalId}`;
	const reviewPromptCacheKey = `${baseCacheKey}:user-${userLogicalId}:review-prompt`;
	const tutorialCacheKey = `${baseCacheKey}:user-${userLogicalId}:tutorial`;
	const appContextBannerCacheKey = `${baseCacheKey}:user-${userLogicalId}:app-context`;
	const consentCacheKey = `${baseCacheKey}:user-${userLogicalId}:consent`;

	return {
		userCacheKey,
		baseCacheKey,
		reviewPromptCacheKey,
		tutorialCacheKey,
		appContextBannerCacheKey,
		consentCacheKey,
	};
};

export default useCacheKey;
